export default __webpack_public_path__ + "045cff2668ecf6414bf586de5ed53be0.png";